import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { Dashboard } from 'src/app/state/dashboard';
import {select, Store} from "@ngrx/store";
import { DashboardSelector } from 'src/app/state/dashboard.selector';


@Component({
  selector: 'app-analytics-multi-years',
  templateUrl: './analytics-multi-years.component.html',
  styleUrls: ['./analytics-multi-years.component.scss']
})
export class AnalyticsMultiYearsComponent implements OnInit {

  public analytics: any[] = [];
  public showXAxis = true;
  public showYAxis = true;
  public gradient = false;
  public showLegend = false;
  public showXAxisLabel = false;
  public xAxisLabel = 'Year';
  public showYAxisLabel = false;
  public yAxisLabel = 'Profit';
  public colorScheme:any = {
    domain: ['#283593', '#039BE5', '#FF5252']
  }; 
  public autoScale = true;
  public roundDomains = true;
  @ViewChild('resizedDiv') resizedDiv!:ElementRef;
  public previousWidthOfResizedDiv:number = 0; 

  dataChart$: Observable<Dashboard> = this.store.pipe(select(DashboardSelector));

  constructor(private store: Store) { }

  ngOnInit(): void {
   
  }

  ngAfterViewChecked() {    
    if(this.previousWidthOfResizedDiv != this.resizedDiv.nativeElement.clientWidth){
      // this.analytics = [...this.data];
    }
    this.previousWidthOfResizedDiv = this.resizedDiv.nativeElement.clientWidth;
  }
}
